import * as storage from "../util/storage";
import { environment } from "../config/environment";


export default async function downloadCompaniesFile() {
  const { apiUrl :  API_URI }  = environment;
  const accessToken = await storage.getAccessToken();
  const bearer = `Bearer ${accessToken}`;

  const url = `${API_URI}/companies/template`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      authorization: bearer,
    },
  });

  return response;
}
